module.exports = "<app-search [query]=\"query\" [data]=\"data\" [type]=\"type\" [cart]=\"cart\" [disable]=\"disable\"></app-search>"